import type { BackendTypes } from '@tf/api';
import { BackendClient } from '@tf/api';
import { splitObjectId } from '@tf/utils';

export const getNodeIdByObjectUri = async (objectId: string): Promise<BackendTypes.GraphId> => {
	const { objectName } = splitObjectId(objectId);
	const res = await BackendClient.getInstance().legacyNodeIdByObjectUri({ objectName: objectName });
	return res.json();
};

export const getObjectUriByNodeId = async (nodeId: BackendTypes.GraphId): Promise<string> => {
	const res = await BackendClient.getInstance().legacyObjectUriByNodeId({ nodeId: nodeId });
	return res.json();
};
